module.exports = "/_next/static/images/6e66247e7637acb8e68465f11ef79fd6-wow-2@1x.svg.webp";